import { schoolImages } from '../data/images';

function HomeBanner() {
  return (
    <main className="home-page">
      <section className="hero" aria-labelledby="hero-title">
        <img className="hero-image" src={schoolImages.hero} alt="Students learning in the school science laboratory beside the campus courtyard" />
        <div className="hero-overlay" />
        <div className="motto-ribbon" aria-label="since1988">
                  <p className="hero-description">Established 1988</p>
        </div>
        <div className="hero-content">
          
          <h1 id="hero-title">Nurturing Potential, <span>Inspiring Futures.</span></h1>
          <p className="hero-description">State-of-the-Art Facilities and Dedicated Faculty.</p>
          <a className="hero-cta" href="#about">Explore Our School <span aria-hidden="true">→</span></a>
        </div>
        <a className="hero-scroll-cue" href="#campus-updates">
          <span className="hero-scroll-label">Discover more</span>
          <span className="hero-scroll-hand" aria-hidden="true">☟</span>
        </a>
      </section>
    </main>
  );
}

export default HomeBanner;
